/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zone_Vo2maxInputs */

const en_ui_zone_vo2max = /** @type {(inputs: Ui_Zone_Vo2maxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO2max`)
};

const de_ui_zone_vo2max = /** @type {(inputs: Ui_Zone_Vo2maxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VO2max`)
};

/**
* | output |
* | --- |
* | "VO2max" |
*
* @param {Ui_Zone_Vo2maxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zone_vo2max = /** @type {((inputs?: Ui_Zone_Vo2maxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zone_Vo2maxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zone_vo2max(inputs)
	return de_ui_zone_vo2max(inputs)
});